import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './business-customer.actions';

@Injectable()
export class BusinessCustomerEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);

    loadPageBusinessCustomer$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadPageBusinessCustomer),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([, dealerSlug]) =>
                from(this.dealerApi.getPageBusinessCustomer(dealerSlug)).pipe(
                    map((content) => actions.loadPageBusinessCustomerSuccess({ content })),
                    catchError((error) => of(actions.loadPageBusinessCustomerFailure({ error }))),
                ),
            ),
        );
    });
}
